import cn from 'clsx'
import styles from './iconrow.css'

const clickables = (onClick?: (arg: unknown) => unknown) => {
  if (!onClick) {
    return {}
  }
  return {
    tabIndex: 0,
    role: 'button',
    onClick,
  }
}

type IconRowProps = {
  title: string
  hoverTitle?: string
  iconUrl?: string
  iconComponent?: JSX.Element
  description: string
  rightComponent?: JSX.Element
  className?: string
  onClick?: (arg: unknown) => unknown
}

const IconRow = ({ title, hoverTitle, iconUrl = '', iconComponent, description, rightComponent, className, onClick }: IconRowProps) => (
  <div className={cn(styles.item, onClick && styles.clickable, className)} {...clickables(onClick)}>
    {iconComponent ? (
      <div className={styles.coverComponentWrapper}>{iconComponent}</div>
    ) : (
      <div className={styles.cover} style={{ backgroundImage: `url(${iconUrl})` }} />
    )}
    <div className={styles.songInfo}>
      <p title={hoverTitle || title}>{title}</p>
      <p title={description}>{description}</p>
    </div>
    {rightComponent}
  </div>
)

export default IconRow
